import { useEffect } from 'react';
import { loadMessaging } from 'utlis/firebase';
import { toast } from 'sonner';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotifications, fetchUnreadCount } from 'store/slices/notificationSlice';
import { getNotificationPath } from 'utlis/notificationRoutes';

/** Route for a push's data: its type + record id (top-level, or inside the `extra` JSON). */
export const pushPath = (data = {}) => {
  let extra = {};
  try { extra = typeof data.extra === 'string' ? JSON.parse(data.extra) : (data.extra || {}); } catch (e) { extra = {}; }
  const id = data.id || data.notify_id || extra.id;
  return getNotificationPath({
    type: data.notify_type || data.type,
    notifiable: { id, type: extra.type, exhibition_id: data.exhibition_id },
  });
};

// Firebase messaging is loaded on demand, and only once someone is actually signed in —
// it used to be imported at the top of App.js, putting the whole SDK in the first load
// for every visitor, including the login page.
const useFirebaseNotifications = () => {
  const dispatch = useDispatch();
  const token = useSelector((s) => s.auth?.token);

  useEffect(() => {
    if (!token) return undefined;

    let unsubscribe = null;
    let cancelled = false;

    loadMessaging().then((fb) => {
      if (!fb || cancelled) return;
      unsubscribe = fb.onMessage(fb.messaging, (payload) => {
        const title =
          payload.notification?.title ||
          payload.data?.title ||
          'Mohilya Updates';

        const body =
          payload.notification?.body ||
          payload.data?.body ||
          'New notification received';

        // ✅ Show toast — "View" opens the record the push is about (it used to open the
        // notifications list for everything)
        toast(`${title} - ${body}`, {
          duration: 5000,
          action: {
            label: 'View',
            onClick: () => {
              window.location.href = pushPath(payload.data);
            },
          },
        });

        // ✅ ADD THIS (refresh notifications)
        dispatch(fetchNotifications({ page: 1, pageSize: 10 }));
        dispatch(fetchUnreadCount());
      });
    });

    return () => {
      cancelled = true;
      if (unsubscribe) unsubscribe();
    };
  }, [dispatch, token]);
};

export default useFirebaseNotifications;
